import { render } from "./Baka.vue?vue&type=template&id=d97309cc"
import script from "./Baka.vue?vue&type=script&lang=js"
export * from "./Baka.vue?vue&type=script&lang=js"

import "./Baka.vue?vue&type=style&index=0&id=d97309cc&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__